import React, { useState } from "react";
import "./FAQ.css";
import { ChevronDown } from "lucide-react";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "Pra quem é a aceleração da Arcadian?",
      answer:
        "Projetamos nossa metodologia para <strong>clínicas e consultórios que desejam operar no segmento premium</strong> – médicos, dentistas e especialistas em saúde que buscam elevar seu ticket médio, construir reputação sólida e adotar um modelo de crescimento previsível.",
    },
    {
      question: "Como são mensurados os resultados?",
      answer:
        "Definimos KPIs antes do onboarding: custo por lead, taxa de conversão em consulta, taxa de fechamento de procedimentos, ticket médio e LTV. Enviamos relatórios executivos semanais e uma análise estratégica mensal, sempre com recomendações acionáveis.",
    },
    {
      question: "O que diferencia a Arcadian de uma agência tradicional?",
      answer:
        "Nossos profissionais estão imersos em uma clínica que fatura mais de R$ 500 mil mensais, o nosso time atua como o “braço direito” no que diz respeito a performance. Temos um time que sabe quais são realmente as práticas que importam e levam a alavancar um faturamento de uma clínica.<br><br>Então colaboramos não só com estratégias de marketing, tráfego pago, relatórios de dados, criação de conteúdo. Mas também destravamos a mentalidade dos nossos parceiros e trazemos práticas de gestão validadas para clínicas.",
    },
    {
      question: "Vocês trabalham com clínicas de outras cidades?",
      answer:
        "Sim. Atuamos <strong>100 % online</strong>, atendendo consultórios em qualquer região do Brasil com o mesmo padrão de precisão e sofisticação. Nossos especialistas oferecem direcionamento estratégico de alto nível, rituais regulares de alinhamento e painéis de métricas em tempo real, garantindo que cada ação seja implantada com excelência — independentemente da distância.",
    },
    {
      question: "Qual é o nível de dedicação exigido da minha equipe?",
      answer:
        "Elevado e estratégico. A Parceria é uma via de mão dupla: entregamos frameworks prontos, mas a transformação acontece quando sua equipe os põe em prática. Depois, bastam checkpoints quinzenais e execução dos nossos direcionamentos. Quanto maior o engajamento, mais rápido o retorno — e estaremos ao lado do seu time, treinando cada membro até que os processos funcionem com fluidez própria.",
    },
    {
      question: "Qual é o investimento necessário para a aceleração?",
      answer:
        "O valor é definido individualmente após nossa avaliação preliminar, levando em conta a maturidade da operação e as metas de crescimento. Trabalhamos apenas em programas de acompanhamento estratégico de médio e longo prazo. Dessa forma, o investimento torna-se proporcional ao resultado projetado e é distribuído em parcelas mensais ao longo do contrato. Para entendermos mais sobre seu projeto, entre em contato.",
    },
    {
      question:
        "Como funciona o processo de gestão de performance da Arcadian?",
      answer:
        "Entramos com o nosso time dentro da estrutura do seu consultório. Criamos uma comunidade e setorizamos cada frente da sua operação (Estratégia, Comercial, Conteúdos). Após uma análise do cenário do cliente vamos definir exatamente as entregas que vão resolver os gargalos dessa operação para cada setor.",
    },
    {
      question: "Qual é o prazo médio para ver resultados?",
      answer:
        "O ritmo de crescimento depende da maturidade da operação e da agilidade com que sua equipe adota os novos processos. Consultórios com cultura receptiva costumam registrar saltos expressivos nos primeiros <strong>60 dias</strong>. Em operações que exigem reestruturações mais profundas, a consolidação tende a ocorrer entre <strong>90 e 180 dias</strong>, com metas progressivas de faturamento rumo ao patamar de seis dígitos mensais. Nosso compromisso é ajustar cada alavanca até que esse resultado se torne recorrente.",
    },
  ];

  return (
    <section id="faq" className="faq-section" data-aos="fade-in">
      <div className="faq-container">
        <div className="faq-header">
          <span className="faq-label">Perguntas Frequentes</span>
          <h2 className="faq-title">
            Tire suas <span className="highlight">dúvidas</span>
          </h2>
          <p className="faq-subtitle">
            As perguntas mais comuns sobre nossa consultoria especializada em
            clínicas e consultórios.
          </p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? "active" : ""}`}
            >
              <button
                className="faq-question"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3>{faq.question}</h3>
                <ChevronDown
                  className={`faq-icon ${openIndex === index ? "rotate" : ""}`}
                />
              </button>
              {openIndex === index && (
                <div
                  className={`faq-answer ${openIndex === index ? "open" : ""}`}
                  style={{ maxHeight: openIndex === index ? "500px" : "0px" }}
                >
                  <p dangerouslySetInnerHTML={{ __html: faq.answer }} />
                </div>
              )}
            </div>
          ))}
        </div>

        <br />
        <br />
        <br />
        <br />
        <div className="faq-header">
          <span className="faq-label">
            Pronto para direcionar sua mensagem como Hermes?
          </span>
          <h2 className="faq-title">
            Pare de apostar no <span className="highlight">próximo lead</span>
          </h2>
          <p className="faq-subtitle">
            Clique no botão abaixo e agende seu diagnóstico gratuito com nosso
            time. Vamos analisar sua operação e te mostrar exatamente onde sua
            mensagem está se perdendo.
          </p>
        </div>

        <div className="faq-bottom-cta">
          <a
            href="https://wa.me/5577981631390?text=Ol%C3%A1%2C%20vim%20do%20site%20da%20Arcadian%20e%20gostaria%20faturar%20mais%20com%20a%20minha%20cl%C3%ADnica!"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="btn-primary">Agendar Diagnóstico</button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
